var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-6 col-md-8" }, [
        _c("h4", { staticClass: "group-name" }, [
          _vm._v(
            "\n                    " + _vm._s(_vm.name) + "\n                "
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "col-6 col-md-4",
          class: { disabled: _vm.isCampCostEditingDisabled && !_vm.newPricing }
        },
        [
          _c("choice", {
            attrs: {
              "option-width": "97px",
              options: _vm.PAY_TYPES,
              value: _vm.free ? _vm.PAY_TYPES[0] : _vm.PAY_TYPES[1]
            },
            on: { input: _vm.onFreeSelect }
          })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        {
          staticClass: "col-6",
          class: { disabled: _vm.isCampCostEditingDisabled && !_vm.newPricing }
        },
        [
          _c(
            "div",
            { staticClass: "price-wrapper form-group" },
            [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "money",
                _vm._b(
                  {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: { required: true, bigger: _vm.free ? false : 0 },
                        expression: "{required: true, bigger: free ? false : 0}"
                      }
                    ],
                    attrs: {
                      maxlength: "15",
                      name: "fee" + _vm.pricing.id,
                      disabled: _vm.free
                    },
                    model: {
                      value: _vm.price,
                      callback: function($$v) {
                        _vm.price = $$v
                      },
                      expression: "price"
                    }
                  },
                  "money",
                  _vm.money,
                  false
                )
              ),
              _vm._v(" "),
              _c("div", { staticClass: "error" }, [
                _vm._v(_vm._s(_vm.errors.first("fee" + _vm.pricing.id)))
              ])
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "col-6",
          class: { disabled: _vm.isCampCostEditingDisabled && !_vm.newPricing }
        },
        [
          _c("select-box", {
            staticClass: "billing",
            attrs: {
              label: "Billing cycle",
              info:
                "<div style='text-align: left'>Select the way parents should be billed<br>\n                                      Per Session - one time upfront fee for the session<br>\n                                      Per Week - charge parent every week the class meets<br>\n                                      Per Monthly - charge parents for camps in that month</div>",
              "default-value": _vm.billingType,
              "data-list": _vm.BILLING_PAYMENT_TYPES,
              "format-callback": function(item) {
                return item.view
              },
              disabled: _vm.free
            },
            on: {
              selected: function($event) {
                _vm.billingType = $event
              }
            }
          })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _vm.showMobileVersion
      ? _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-6 offset-6 mb-20" },
            [
              _c("number-peel", {
                staticClass: "mb-0",
                attrs: { label: "Max Enroll", name: "max-enroll" },
                model: {
                  value: _vm.maxEnroll,
                  callback: function($$v) {
                    _vm.maxEnroll = $$v
                  },
                  expression: "maxEnroll"
                }
              })
            ],
            1
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-6 col-sm-4 is-waitlist" },
        [
          _c("switch-button", {
            attrs: { checked: _vm.waitList, label: "Wait list" },
            on: {
              "update:checked": function($event) {
                _vm.waitList = $event
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      !_vm.showMobileVersion
        ? _c(
            "div",
            { staticClass: "col-6 col-sm-4" },
            [
              _c("number-peel", {
                staticClass: "mb-0",
                attrs: { label: "Max Enroll", name: "max-enroll" },
                model: {
                  value: _vm.maxEnroll,
                  callback: function($$v) {
                    _vm.maxEnroll = $$v
                  },
                  expression: "maxEnroll"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-6 col-sm-4" },
        [
          _c("number-peel", {
            staticClass: "mb-0",
            attrs: {
              label: "Wait list max",
              name: "wait-list-max",
              "min-value": 1,
              disabled: !_vm.waitList,
              "initial-value": _vm.maxWaitList
            },
            model: {
              value: _vm.maxWaitList,
              callback: function($$v) {
                _vm.maxWaitList = $$v
              },
              expression: "maxWaitList"
            }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-flex align-items-center" }, [
      _c("label", [_vm._v("Fee")]),
      _vm._v(" "),
      _c("div", { staticClass: "with-tooltip fee" }, [
        _c("img", {
          staticClass: "info-tooltip",
          attrs: { src: require("../../../../assets/img/question.svg") }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "tooltiptext" }, [
          _vm._v(
            "\n                                Enter the total amount parent will pay per billing cycle\n                            "
          )
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-07206e36", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07206e36","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/pages/camp-form/CampPricingEnd.vue
// module id = null
// module chunks = 